const portal = {
  layout: {
    title: "Kundenportal",
    startPage: "Zur Startseite",
    mainNavigation: "Hauptnavigation",
  },
  navigation: {
    clientFile: "Mein Kundenakt",
    fileUpload: "Dateien hochladen",
    spousalMaintenance: "Unterhaltsanspruch berechnen",
  },
  userMenu: {
    open: "Benutzermenü öffnen",
    changePassword: "Passwort ändern",
    logout: "Abmelden",
  },
  clientFile: {
    loadError: "Ihr Kundenakt konnte nicht geladen werden. Bitte versuchen Sie es später erneut.",
    tabs: {
      clientNote: "Notizen",
      assetInventory: "Vermögensverzeichnis",
      claims: "Verbindlichkeiten",
      bankruptcyChecklist: "Konkurs Checkliste",
    },
    clientNote: {
      noticeText:
        "Achtung: Das, was Sie hier eingeben, wird nicht automatisch von Ihrem Berater bzw. Ihrer Beraterin gelesen. Sie können hier also keine Nachrichten für Ihren Berater oder Ihre Beraterin hinterlassen. Wenn Sie Nachrichten für Ihren Berater oder Ihre Beraterin haben, so rufen Sie ihn bzw. sie an.",
      cardTitle: "Notizen (für Berater:in sichtbar)",
    },
  },
  passwordChangeSuccess: "Ihr Passwort wurde erfolgreich geändert.",
};

export default portal;
